import React from 'react';
import { string } from 'prop-types';

const FlashIcon = ({ color = 'sixth-color', fontSize = 'var(--base-large)', className = '' }) => (
  <span
    style={{
      color: `var(--${color})`,
      fontSize: fontSize
    }}
    className={`icon-ic_flash ${className}`}
  />
);

FlashIcon.propTypes = {
  color: string,
  fontSize: string,
  className: string
};

export default FlashIcon;
